import { createFileRoute } from "@tanstack/react-router";

import { OrdersPageConnector } from "@pages/orders";

export const Route = createFileRoute("/_private/orders/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <OrdersPageConnector />;
}
